var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:( _obj = {}, _obj[_vm.className] = _vm.className, _obj ),attrs:{"tag":_vm.tag,"css":false,"name":"fadeTranslateToBottom"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave,"before-appear":_vm.beforeEnter,"appear":_vm.enter}},[_vm._t("default")],2)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-052bf478","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FadeTranslateTransitionGroup.vue
// module id = null
// module chunks = 